import rest from 'Services/restFootData';
import { getProject } from 'Services/project';
import qs from 'query-string';

function toParams(search) {
  if (!search) return {};
  return typeof search === 'string' ? qs.parse(search) : search;
}

export function fetchBroadcastAffiliation(id) {
  return function(dispatch) {
    dispatch({ type: 'FETCH_BROADCAST_AFFILIATION' });

    return rest
      .get(`broadcast_affiliations/${id}`)
      .then(
        res => dispatch({ type: 'FETCH_BROADCAST_AFFILIATION_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_BROADCAST_AFFILIATION_REJECTED', payload: err.response })
      );
  };
}

export function fetchBroadcastAffiliations(search) {
  const params = {
    'order[createdAt]': 'desc',
    groups: ['read_link'],
    itemsPerPage: 30,
    partial: 0,
    ...toParams(search),
    // Broadcast affiliations are managed per footadmin locale (current project).
    locale: getProject().lang,
  };

  return function(dispatch) {
    dispatch({ type: 'FETCH_BROADCAST_AFFILIATIONS' });

    return rest
      .get('broadcast_affiliations', { params })
      .then(
        res => dispatch({ type: 'FETCH_BROADCAST_AFFILIATIONS_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_BROADCAST_AFFILIATIONS_REJECTED', payload: err.response })
      );
  };
}

export function updateBroadcastAffiliation(id, affiliation) {
  return function(dispatch) {
    dispatch({ type: 'UPDATE_BROADCAST_AFFILIATION' });

    return rest.put(`broadcast_affiliations/${id}`, affiliation).then(
      res => {
        dispatch({
          type: 'ADD_NOTIFICATION',
          payload: { messageKey: 'message_broadcastAffiliationUpdated', type: 'success' },
        });
        return dispatch({ type: 'FETCH_BROADCAST_AFFILIATION_FULFILLED', payload: res.data });
      },
      err => dispatch({ type: 'UPDATE_BROADCAST_AFFILIATION_REJECTED', payload: err.response })
    );
  };
}

export function deleteBroadcastAffiliation(id) {
  return function(dispatch) {
    dispatch({ type: 'DELETE_BROADCAST_AFFILIATION' });

    return rest
      .delete(`broadcast_affiliations/${id}`)
      .then(
        () => dispatch({ type: 'DELETE_BROADCAST_AFFILIATION_FULFILLED', payload: id }),
        err => dispatch({ type: 'DELETE_BROADCAST_AFFILIATION_REJECTED', payload: err.response })
      );
  };
}

export function addBroadcastAffiliation(affiliation) {
  return function(dispatch) {
    dispatch({ type: 'ADD_BROADCAST_AFFILIATION' });

    return rest.post('broadcast_affiliations', affiliation).then(
      res => {
        dispatch({
          type: 'ADD_NOTIFICATION',
          payload: { messageKey: 'message_broadcastAffiliationAdded', type: 'success' },
        });
        return dispatch({ type: 'ADD_BROADCAST_AFFILIATION_FULFILLED', payload: res.data });
      },
      err => dispatch({ type: 'ADD_BROADCAST_AFFILIATION_REJECTED', payload: err.response })
    );
  };
}
